
export default function Header({ userId }) {
  return (
    <header className="page-header">
      <h1 style={{ color: "purple" }}>Control Application</h1>
    </header>
  );
}
